import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import PageHeader from '@dashboard/components/PageHeader';
import NavTabs from '@dashboard/components/NavTabs';

import AccountProfile from './scenes/AccountProfile';
import AccountEmails from './scenes/AccountEmails';

const tabs = [
  {
    name: 'Profile',
    href: '/account/profile',
    component: AccountProfile,
  },
  {
    name: 'Email notifications',
    href: '/account/emails',
    component: AccountEmails,
  },
];

const Account = () => {
  const { pathname } = useLocation();
  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Account"
        description="Manage your personal details, password, and email notifications."
      >
        <NavTabs aria-label="Account settings">
          {tabs.map(tab => (
            <NavTabs.Item key={tab.name} to={tab.href} active={pathname === tab.href}>
              {tab.name}
            </NavTabs.Item>
          ))}
        </NavTabs>
      </PageHeader>

      <div className="mb-32">
        <Switch>
          {tabs.map(tab => (
            <Route key={tab.href} path={tab.href} component={tab.component} />
          ))}
        </Switch>
      </div>
    </div>
  );
};

export default Account;
